import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layout/MainLayout';
import HomePage from './pages/HomePage';

const Immersive_Servicios = lazy(() => import('./pages/Immersive_Servicios'));
const Immersive_Blog = lazy(() => import('./pages/Immersive_Blog'));
const Immersive_Nosotros = lazy(() => import('./pages/Immersive_Nosotros'));
const Immersive_Contacto = lazy(() => import('./pages/Immersive_Contacto'));
const TestTDAH = lazy(() => import('./pages/TestTDAH'));

function App() {
  return (
    <Router>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/Immersive_Servicios" element={<MainLayout><Immersive_Servicios /></MainLayout>} />
          <Route path="/Immersive_Blog" element={<MainLayout><Immersive_Blog /></MainLayout>} />
          <Route path="/Immersive_Nosotros" element={<MainLayout><Immersive_Nosotros /></MainLayout>} />
          <Route path="/Immersive_Contacto" element={<MainLayout><Immersive_Contacto /></MainLayout>} />
          <Route path="/test-tdah" element={<MainLayout><TestTDAH /></MainLayout>} />
          {/* Acceso directo a la sala de cada especialista. Los slugs válidos
              están en src/config/rooms.js; uno desconocido cae en HomePage y
              arranca el recorrido normal desde recepción. */}
          <Route path="/sala/:slug" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="*" element={<MainLayout><HomePage /></MainLayout>} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;